import { DEVICE_HEARTBEAT_INTERVAL_MS } from '@2meters/types'
import { useEffect, useRef } from 'react'
import { kioskHeartbeat } from 'api/backend/kioskHeartbeat'

const SESSION_KEY = 'kiosk-session-id'

function getOrCreateSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY)
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem(SESSION_KEY, id)
  }
  return id
}

export function useKioskHeartbeat(placeId: string | undefined, kioskCode: string | undefined) {
  const activeRef = useRef(false)

  useEffect(() => {
    if (!placeId || !kioskCode) return

    const sessionId = getOrCreateSessionId()
    activeRef.current = true

    const send = () => {
      if (!activeRef.current) return
      kioskHeartbeat({ placeId, kioskCode, sessionId }).catch(() => {
        // heartbeat failures are non-critical
      })
    }

    send()
    const interval = setInterval(send, DEVICE_HEARTBEAT_INTERVAL_MS)

    return () => {
      activeRef.current = false
      clearInterval(interval)
    }
  }, [placeId, kioskCode])
}
